export default __webpack_public_path__ + "static/media/attendance.bbaa815b.png";